<coso-replicator-page-header [title]="'Connections'"></coso-replicator-page-header>
@if (isRunning) {
<alert type="warning">
  <coso-alert-message>You can only modify the content of this page once the replication process is stopped.</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if (warningMessage) {
<alert type="warning" [dismissible]="true" (onClose)="warningMessage = undefined">
  <coso-alert-message>{{ warningMessage }}</coso-alert-message>
</alert>
} @if ({ isLoading: loadingService.isAnySpinnerActive$ | async }; as loadingState) { @if (!loadingState.isLoading) {
<div>
  <h2 class="text-primary">Dynamics 365 connection</h2>
  @if (!dynamics365Connection?.server) {
  <a class="btn btn-primary" routerLink="dynamics-365" [class.disabled]="isReadOnly"><span class="fa fa-fw fa-cog mr-1" aria-hidden="true"></span>Configure</a>
  } @else {
  <div role="region" aria-label="List of Dynamics 365 connections">
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="d365GridColDefs" [rowData]="[dynamics365Connection]"></coso-grid>
  </div>
  }
  <ng-template #d365Grid>
    <div role="region" aria-label="List of Dynamics 365 connections">
      <coso-grid [gridOptions]="gridOptions" [columnDefs]="d365GridColDefs" [rowData]="[dynamics365Connection]"></coso-grid>
    </div>
  </ng-template>
</div>
@if (groupStorage === GroupStorage.ActiveDirectory && isSaaS === false) {
<div class="mt-5">
  <h2 class="text-primary">Active Directory connection</h2>
  @if (isSaaS === false && isFailoverBackupInstance) {
  <alert type="warning">
    <coso-alert-message>This configuration is taken automatically from main instance, and therefore is read-only.</coso-alert-message>
  </alert>
  } @if (!adConnection?.connectionData?.server && !isFailoverBackupInstance) {
  <a class="btn btn-primary" routerLink="active-directory" [class.disabled]="isReadOnly"><span class="fa fa-fw fa-cog mr-1" aria-hidden="true"></span>Configure</a>
  } @else {
  <div role="region" aria-label="List of Active Directory connections">
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="adGridColDefs" [rowData]="[adConnection]"></coso-grid>
  </div>
  }
  <ng-template #adGrid>
    <div role="region" aria-label="List of Active Directory connections">
      <coso-grid [gridOptions]="gridOptions" [columnDefs]="adGridColDefs" [rowData]="[adConnection]"></coso-grid>
    </div>
  </ng-template>
</div>
} @if (groupStorage === GroupStorage.AzureActiveDirectory) {
<div class="mt-5">
  <h2 class="text-primary">Microsoft Entra ID connection</h2>
  @if (isSaaS === false && isFailoverBackupInstance) {
  <alert type="warning">
    <coso-alert-message>This configuration is taken automatically from main instance, and therefore is read-only.</coso-alert-message>
  </alert>
  } @if (!azureAdConnection?.server && azureAdConnection?.authentication?.authenticationType !== TargetSystemAuthenticationType.ModernManagedIdentity && !isFailoverBackupInstance) {
  <a class="btn btn-primary" routerLink="entra-id" [class.disabled]="isReadOnly"><span class="fa fa-fw fa-cog mr-1" aria-hidden="true"></span>Configure</a>
  } @else {
  <div role="region" aria-label="List of Microsoft Entra ID connections">
    @if (azureAdConnection?.authentication?.authenticationType !== TargetSystemAuthenticationType.ModernManagedIdentity) {
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="azureAdGridColDefs" [rowData]="[azureAdConnection]"></coso-grid>
    } @if (azureAdConnection?.authentication?.authenticationType === TargetSystemAuthenticationType.ModernManagedIdentity) {
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="azureAdManagedIdentityGridColDefs" [rowData]="[azureAdConnection]"></coso-grid>
    }
  </div>
  }
  <ng-template #aadGrid>
    <div role="region" aria-label="List of Microsoft Entra ID connections">
      @if (azureAdConnection?.authentication?.authenticationType !== TargetSystemAuthenticationType.ModernManagedIdentity) {
      <coso-grid [gridOptions]="gridOptions" [columnDefs]="azureAdGridColDefs" [rowData]="[azureAdConnection]"></coso-grid>
      } @if (azureAdConnection?.authentication?.authenticationType === TargetSystemAuthenticationType.ModernManagedIdentity) {
      <coso-grid [gridOptions]="gridOptions" [columnDefs]="azureAdManagedIdentityGridColDefs" [rowData]="[azureAdConnection]"></coso-grid>
      }
    </div>
  </ng-template>
</div>
}
<div class="mt-5">
  <h2 class="text-primary">SharePoint connections</h2>
  @if (isSaaS === false && isFailoverBackupInstance) {
  <alert type="warning">
    <coso-alert-message>This configuration is taken automatically from main instance, and therefore is read-only.</coso-alert-message>
  </alert>
  }
  <div class="mb-3">
    <a class="btn btn-primary" [class.disabled]="isReadOnly || (groupStorage !== GroupStorage.SharePoint && isSaaS === true) || isFailoverBackupInstance" [routerLink]="['sharepoint', 'create']">
      <span class="fa fa-fw fa-plus mr-1" aria-hidden="true"></span>Create new
    </a>
  </div>
  <div role="region" aria-label="List of SharePoint connections">
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="spGridColDefs" [rowData]="spConnections"></coso-grid>
  </div>
</div>
<a class="btn btn-dark mt-5" [routerLink]="['/', 'configuration']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Configurations list</a>
} }

<ng-template #d365ActionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm" role="group">
    <a
      class="btn btn-dark"
      routerLink="dynamics-365"
      data-toggle="tooltip"
      title="{{ isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' }} Dynamics 365 connection"
      [attr.aria-label]="isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' + 'Dynamics 365 connection'"
    >
      <span class="fa fa-fw" [ngClass]="{ 'fa-edit': !(isReadOnly || isFailoverBackupInstance), 'fa-eye': isReadOnly || isFailoverBackupInstance }" aria-hidden="true"></span>
    </a>
  </div>
</ng-template>
<ng-template #aadActionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm" role="group">
    <a
      class="btn btn-dark"
      routerLink="entra-id"
      data-toggle="tooltip"
      title="{{ isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' }} Entra ID connection"
      [attr.aria-label]="isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' + 'Entra ID connection'"
    >
      <span class="fa fa-fw" [ngClass]="{ 'fa-edit': !(isReadOnly || isFailoverBackupInstance), 'fa-eye': isReadOnly || isFailoverBackupInstance }" aria-hidden="true"></span>
    </a>
  </div>
</ng-template>
<ng-template #adActionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm" role="group">
    <a
      class="btn btn-dark"
      routerLink="active-directory"
      data-toggle="tooltip"
      title="{{ isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' }} Active Directory connection"
      [attr.aria-label]="isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' + 'Active Directory connection'"
    >
      <span class="fa fa-fw" [ngClass]="{ 'fa-edit': !(isReadOnly || isFailoverBackupInstance), 'fa-eye': isReadOnly || isFailoverBackupInstance }" aria-hidden="true"></span>
    </a>
  </div>
</ng-template>
<ng-template #spActionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm" role="group">
    <a
      [attr.aria-label]="(isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit') + ' SharePoint connection ' + params.data.name"
      class="btn btn-dark mr-1"
      data-toggle="tooltip"
      title="{{ isReadOnly || isFailoverBackupInstance ? 'View' : 'Edit' }} SharePoint connection"
      [routerLink]="['sharepoint', params.data.key]"
    >
      <span class="fa fa-fw" [ngClass]="{ 'fa-edit': !(isReadOnly || isFailoverBackupInstance), 'fa-eye': isReadOnly || isFailoverBackupInstance }" aria-hidden="true"></span>
    </a>
    <a
      class="btn btn-dark mr-1"
      [class.disabled]="params.data.webId === DEFAULT_GUID || params.data.loadDistributedConnectionFor"
      data-toggle="tooltip"
      title="User mapping"
      [routerLink]="['sharepoint', params.data.key, 'user-mapping']"
      [attr.aria-label]="'User mapping for ' + params.data.name"
    >
      <span class="icon-stack">
        <i class="fa fa-fw fa-user" aria-hidden="true"></i>
        <i class="fa fa-fw fa-exchange icon-stack-smaller-secondary" aria-hidden="true"></i>
      </span>
    </a>
    <a
      class="btn btn-dark mr-1"
      [class.disabled]="params.data.webId === DEFAULT_GUID || params.data.loadDistributedConnectionFor"
      data-toggle="tooltip"
      title="Permission mapping"
      [routerLink]="['sharepoint', params.data.key, 'permission-mapping']"
      [attr.aria-label]="'Permission mapping for ' + params.data.name"
    >
      <span class="icon-stack">
        <i class="fa fa-fw fa-lock" aria-hidden="true"></i>
        <i class="fa fa-fw fa-exchange icon-stack-smaller-secondary" aria-hidden="true"></i>
      </span>
    </a>
    <a
      class="btn btn-dark mr-1"
      [class.disabled]="params.data.webId === DEFAULT_GUID || params.data.loadDistributedConnectionFor"
      data-toggle="tooltip"
      title="Explicit folder permissions"
      [routerLink]="['sharepoint', params.data.key, 'explicit-folder-permissions']"
      [attr.aria-label]="'Explicit folder permissions for ' + params.data.name"
    >
      <span class="fa-stack fa-stack-xs">
        <i class="fa fa-folder fa-stack-2x" aria-hidden="true"></i>
        <i class="fa fa-lock fa-stack-1x text-secondary" aria-hidden="true"></i>
      </span>
    </a>
    <button
      class="btn btn-dark mr-1"
      [disabled]="
        params.data.webId === DEFAULT_GUID ||
        groupStorage !== GroupStorage.SharePoint ||
        automaticSharePointUserCreation === AutomaticSharePointUserCreationMode.Disabled ||
        params.data.loadDistributedConnectionFor
      "
      data-toggle="tooltip"
      title="Groups"
      [routerLink]="['sharepoint', params.data.key, 'groups']"
      [attr.aria-label]="'Groups for ' + params.data.name"
    >
      <span class="fa-stack fa-stack-xs">
        <i class="fa fa-users fa-stack-2x" aria-hidden="true"></i>
      </span>
    </button>
    <button
      id="delete#{{ params.data.key }}"
      class="btn btn-danger"
      data-toggle="tooltip"
      title="Delete SharePoint connection"
      [disabled]="isReadOnly || !params.data.canBeDeleted"
      (click)="confirmDeletion(params.data)"
      [attr.aria-label]="'Delete SharePoint connection ' + params.data.name + '?'"
    >
      <span class="fa fa-fw fa-trash" aria-hidden="true"></span>
    </button>
  </div>
</ng-template>
